export default __webpack_public_path__ + "static/media/roy_robins.a6f9eb2c.jpg";